module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Upload.5d98bcbd.svg";